import * as React from 'react';
import { LinkedAccountI18n } from './page-account-linked-accounts';
import { ColorHelper, em, percent, px } from 'csx';
import {
  center, endJustified, flex1, horizontal, horizontallySpaced, startJustified, vertical, verticallySpaced
} from 'csstips';
import { classes, style } from 'typestyle';
import {ButtonPill, buttonPillHelpers} from './button-pill';
import { mediaMobileOnly } from '../theme/media';
import { colorWhite } from '../theme/color';

export interface PageAccountLinkedAccountProps {
  Icon: any;
  name: string;
  linkURL: string;
  isLinked: boolean;
  isUnlinking: boolean;
  color: ColorHelper;
  i18n: LinkedAccountI18n;
  onUnlink(): void;
  onLink?(event: React.MouseEvent<any>): void;
};

export class PageAccountLinkedAccount extends React.Component<PageAccountLinkedAccountProps, any> {
  render() {
    const { Icon, i18n, linkURL, name, isUnlinking, onLink, isLinked, color, onUnlink } = this.props;

    return (
      <div className={PageAccountLinkedAccount.styles.container}>
        <div className={PageAccountLinkedAccount.styles.header}>
          <div className={PageAccountLinkedAccount.styles.title}>
            <Icon color={color.toString()} size={40} />
            <h5>{i18n.header}</h5>
          </div>
          <div className={PageAccountLinkedAccount.styles.buttons}>
            {isLinked && (
              <ButtonPill muted={true} onClick={onUnlink} disabled={isUnlinking}>
                {isUnlinking ? i18n.unlinking : `${name ? `${name} - `:''}${i18n.unlink}`}
              </ButtonPill>
            )}
            {!isLinked && (
              <a href={onLink ? '#' : linkURL} className={style(buttonPillHelpers.customColor(color, colorWhite, true))} onClick={onLink} rel="nofollow">
                {i18n.link}
              </a>
            )}
          </div>
        </div>
        <p>{i18n.content}</p>
      </div>
    )
  }

  static styles = {
    container: style({
      ...vertical,
      ...verticallySpaced(10),
      $nest: {
        '& h5': {
          margin: '4px 0',
          fontSize: px(18)
        },
        '& p': {
          maxWidth: em(50),
          margin: '10px 0 0 0',
        }
      }
    }),
    header: style(
      {
      ...horizontal,
      ...horizontallySpaced(20),
      ...center,
      },
      mediaMobileOnly({
        ...vertical,
        ...verticallySpaced(10),
      })
    ),
    title: style({
      ...horizontal,
      ...horizontallySpaced(20),
      ...center,
    }),
    buttons: style(
      {
        ...horizontal,
        ...endJustified,
        ...center,
        ...flex1,
        $nest: {
          '&> *': {
            maxWidth: percent(100),
            textAlign: 'center',
          }
        }
      },
      mediaMobileOnly({
        ...horizontal,
        ...startJustified
      })
    )
  }
}